import React, { useState } from 'react';
import VehicleHistoryComponent from '../components/common/work-orders/VehicleHistory';
import {
  Container,
  Row,
  Col,
} from "shards-react";
import PageTitle from "../components/common/PageTitle";

function VehicleHistory(props) {
	const { plate } = props.match.params;
	return (
		<Container fluid className="main-content-container">
			<Row noGutters className="page-header py-4">
				<Col md="12" sm="12">
					<PageTitle title="Historial" subtitle="Vehiculo" className="text-sm-left mb-3" />
				</Col>
			</Row>
			<Row noGutters className="page-header py-4">
				<Col md="12" sm="12">
					<VehicleHistoryComponent plate={plate} margin={false}/>
				</Col>
			</Row>
		</Container>
	);
}

export default VehicleHistory;

